import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconApps32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconApps32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12 6H6.5a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 .5.5H12a.5.5 0 0 0 .5-.5V6.5A.5.5 0 0 0 12 6M6.5 4A2.5 2.5 0 0 0 4 6.5V12a2.5 2.5 0 0 0 2.5 2.5H12a2.5 2.5 0 0 0 2.5-2.5V6.5A2.5 2.5 0 0 0 12 4zm0 15.5H12a.5.5 0 0 1 .5.5v5.5a.5.5 0 0 1-.5.5H6.5a.5.5 0 0 1-.5-.5V20a.5.5 0 0 1 .5-.5M4 20a2.5 2.5 0 0 1 2.5-2.5H12a2.5 2.5 0 0 1 2.5 2.5v5.5A2.5 2.5 0 0 1 12 28H6.5A2.5 2.5 0 0 1 4 25.5zm16-.5h5.5a.5.5 0 0 1 .5.5v5.5a.5.5 0 0 1-.5.5H20a.5.5 0 0 1-.5-.5V20a.5.5 0 0 1 .5-.5m-2.5.5a2.5 2.5 0 0 1 2.5-2.5h5.5A2.5 2.5 0 0 1 28 20v5.5a2.5 2.5 0 0 1-2.5 2.5H20a2.5 2.5 0 0 1-2.5-2.5zm5.25-15.875a1 1 0 0 1 1 1V8.25h3.125a1 1 0 1 1 0 2H23.75v3.125a1 1 0 1 1-2 0V10.25h-3.125a1 1 0 1 1 0-2h3.125V5.125a1 1 0 0 1 1-1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconApps32);
